import { MessageDescriptor, useIntl } from 'react-intl';

import { EUnit } from '../model';

export type TMessagesFormatUnit = {
  [key in EUnit]: MessageDescriptor;
};

/**
 * Convert's enum `Unit` to language translated string
 */
export const useFormatUnit = (messages: TMessagesFormatUnit) => {
  const { formatMessage } = useIntl();
  return (unit: EUnit) => formatMessage(messages[unit]);
};
